import type * as OnrampCTA from '../types/OnrampCTA'

export default function onrampCTAComponentParser(
  rawComponent: OnrampCTA.Raw,
): OnrampCTA.Parsed {
  const props = rawComponent.onrampCta

  return {
    name: 'OnrampCTA',
    props,
  }
}
